import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M30 150q0-40 40-40h60q40 0 40 40v12h-20v-12h-20v12h-20v-12H90v12H70v-12Z" }, null, -1),
    _createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "16",
      d: "M130 110q8-30 22-40 16-10 20-30-2-12-14-12-10 4-10 16"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "160",
      cy: "36",
      r: "4",
      fill: "var(--mc-avatar)"
    }, null, -1)
  ]))]))
}
export default { render: render }